import styled from 'styled-components';

const InfoSection = (props) => {
    const { type = 'acropolis', isFromADEN, countryCode } = props;
    const isFromAR = countryCode === 'AR';

    return (
        <Container type={type}>
            {!isFromADEN && !isFromAR && (
                <>
                    <h2>¿Cómo acceder al beneficio?</h2>
                    <p>
                        Se dará un bono en cash por PayPal a quienes den{' '}
                        <b>invitados matriculados. </b>
                        Para recibir el pago, el invitado{' '}
                        <b>debe abonar la segunda cuota de su programa.</b>
                    </p>
                </>
            )}
            {isFromAR && (
                <>
                    <h2>¿Cómo acceder al beneficio?</h2>
                    <p>
                        Se otorgará un crédito en pesos para futuras formaciones
                        a los alumnos o egresados que recomienden a una persona
                        nueva. Para que el beneficio se acredite efectivamente,{' '}
                        <b>
                            el invitado debe haber abonado la segunda cuota de
                            su programa académico.
                        </b>
                    </p>
                    <p>
                        El monto del crédito para el referidor dependerá de la
                        formación que adquiera su invitado.
                    </p>
                </>
            )}
            <h2>Términos y condiciones</h2>
            {!isFromAR &&
                (isFromADEN ? (
                    <>
                        <p>
                            El invitado será válido si{' '}
                            <b>no se encuentra en la base de datos de ADEN</b> o
                            si no tiene actividad registrada en los últimos{' '}
                            <b>dos años</b>.
                        </p>
                        <p>
                            El programa <b>no es compatible</b> con el programa
                            de becas internas en lo que respecta a descuentos
                            para familiares directos.
                        </p>
                        <p>
                            El premio se abonará{' '}
                            <b>a partir de la segunda cuota integrada</b> según
                            el tarifario vigente.
                        </p>
                        <p>
                            No existe un límite en la cantidad de invitados que
                            un colaborador puede registrar, siempre que cumplan
                            con los criterios establecidos.
                        </p>
                        <p>
                            El premio se abonará en moneda local como
                            gratificación, a mes vencido, respetando el período
                            de carga de novedades del 20 al 20 de cada mes. Se
                            aplicará el tipo de cambio ADEN vigente en la fecha
                            de pago. En caso de pago único por parte del
                            estudiante, el premio se otorgará en la siguiente
                            liquidación. Si el estudiante opta por el pago en
                            cuotas, el premio se percibirá en el segundo mes.
                        </p>
                    </>
                ) : (
                    <>
                        <p>
                            Para ser considerado apto en este programa,{' '}
                            <b>
                                la persona invitada debe ser nueva en el Grupo
                                Educativo ADEN
                            </b>
                            , es decir, no debe estar registrada previamente ni
                            haber tenido algún contacto o relación, como ser
                            alumno, empleado o haber iniciado un proceso de
                            inscripción en cualquier programa ofrecido por ADEN.{' '}
                            <b>
                                No aplica a quienes se matriculen por medio de
                                la Beca Globo Común.
                            </b>
                        </p>
                        <p>
                            El programa está abierto únicamente para aquellos{' '}
                            <b>
                                referentes que sean alumnos activos o que hayan
                                egresado de ADEN.{' '}
                            </b>
                            Las recompensas monetarias se procesarán{' '}
                            <b>exclusivamente a través de PayPal,</b> y para que
                            el referente sea elegible para recibir su
                            recompensa,
                            <b>
                                {' '}
                                la persona recomendada debe haber realizado el
                                pago de su segunda cuota académica.
                            </b>
                        </p>
                        <p>
                            Además,{' '}
                            <b>
                                esta última obtendrá un descuento porcentual (%)
                                en el costo de su programa académico.
                            </b>{' '}
                            Cabe destacar que ADEN se reserva el derecho a
                            cualquier momento de modificar o terminar el
                            programa sin previo aviso.
                        </p>
                    </>
                ))}
            {isFromAR && (
                <ul>
                    <li>
                        <strong>Participantes: </strong>El programa está abierto
                        exclusivamente para estudiantes activos y egresados de
                        ADEN.
                    </li>
                    <li>
                        <strong>Política de uso: </strong>Los créditos otorgados
                        no son canjeables por dinero en efectivo. Podrán
                        utilizarse para el pago de futuras formaciones propias o
                        ser transferidos a familiares o terceros para su
                        inscripción.
                    </li>
                    <li>
                        <strong>Acumulación: </strong>Los créditos pueden
                        sumarse entre sí y son acumulables con convenios de
                        partnership, respetando siempre un tope máximo de
                        beneficio del <b>28%</b>.
                    </li>
                    <li>
                        <strong>Beneficio para el referidor: </strong>Si la
                        persona referida adquiere un Programa de Formación
                        Ejecutiva, Programa Especializado o un Major, el
                        referente recibirá un crédito de <b>$75.000</b> para ser
                        utilizado en futuras formaciones. Si el referido opta
                        por una Maestría o un MBA, el beneficio asciende a un
                        crédito de <b>$220.000</b>.
                    </li>
                    <li>
                        <strong>Beneficio para el invitado: </strong>La persona
                        invitada obtendrá un descuento directo en su matrícula
                        según el programa elegido:
                        <ul>
                            <li>
                                10% de bonificación en Programas Especializados
                                de Formación Ejecutiva o Majors.
                            </li>
                            <li>20% de bonificación en Maestrías o MBA.</li>
                        </ul>
                    </li>
                    <li>
                        <strong>Vigencia: </strong>Estas condiciones y
                        beneficios son válidos hasta el <b>31/12/2026</b>.
                    </li>
                </ul>
            )}
        </Container>
    );
};

export default InfoSection;

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2rem;
    margin: ${(props) => props.type === 'landing' && '0 14rem'};

    h2 {
        font-size: 24px;
        color: #b31d15;

        b {
            font-size: 24px;
        }
    }

    p {
        font-size: 20px;
        color: #222222;

        b {
            font-size: 20px;
        }
    }

    ul {
        margin-left: 1.5rem;
        display: flex;
        flex-direction: column;
        gap: 1rem;

        li {
            ul {
                margin-top: 0.5rem;
                margin-right: 2rem;
            }
        }
    }

    @media (max-width: 1300px) {
        margin: 0 4rem;
    }
`;
